import React, { useState, useRef } from 'react';
import { Drawer, Form, Input, Row, Col, Select, Space, message, Switch, Button } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { insert, update, getById } from '../../../../apis/DefinicionFormatoBancoApi';
import { getBancosOdoo as getAllBanco } from '../../../../apis/BancosApi';

const { Option } = Select;
const { TextArea } = Input;

const App = ({ title, id, open, finish }) => {
  const [form] = Form.useForm();
  const [ID, setID] = useState(id);
  const [initialValues, setInitialValues] = useState(null);
  const [bancos, setBancos] = useState([]);

  const handleOk = async () => {
    const fields = form.getFieldsValue();

    // Encontrar el banco seleccionado para obtener tanto la clave como el nombre
    const selectedBanco = bancos.find(banco => banco.value === fields.banco_clave);

    if (ID > 0) {
      // Update
      const payload = {
        id: ID,
        banco_clave: fields.banco_clave,
        banco_nombre: selectedBanco?.text || '',
        formato: fields.formato || null,
        comentarios: fields.comentarios || null,
        activo: fields.activo
      };
      const response = await update(payload);
      if (response.ok) {
        message.success('Se actualizó correctamente!');
        finish(true);
      }
    } else {
      // Create
      const payload = {
        banco_clave: fields.banco_clave,
        banco_nombre: selectedBanco?.text || '',
        formato: fields.formato || null,
        comentarios: fields.comentarios || null,
        activo: fields.activo
      };
      const response = await insert(payload);
      if (response.ok) {
        setID(response.payload);
        message.success('Se guardó correctamente!');
        finish(true);
      }
    }
  };

  const onClose = () => {
    finish(false);
    setInitialValues(null);
  };

  const effectRan = useRef(false);
  React.useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await getCatalogs();
        if (ID > 0) {
          await refreshData();
        } else {
          setInitialValues({
            banco_clave: null,
            formato: '',
            activo: true,
            comentarios: ''
          });
        }
      })();
    }
    return () => effectRan.current = true;
  }, [ID]);

  const refreshData = async () => {
    const response = await getById(ID);
    if (response.ok) {
      setInitialValues(response.payload);
    }
  };

  const getCatalogs = async () => {
    const responseBancos = await getAllBanco();
    if (responseBancos && responseBancos.ok && responseBancos.payload) {
      let bancosItems = responseBancos.payload.map(item => ({
        value: item.odoo_id,
        text: item.name,
        id: item.odoo_id,
      }));
      setBancos(bancosItems);
    }
  };

  return (
    <Drawer
      title={<>
        {ID > 0 ? '(' + ID + ') ' : ''}
        {title}
      </>}
      width={'50%'}
      placement={"right"}
      onClose={onClose}
      open={open}
      closable={true}
      styles={{
        body: {
          paddingBottom: 80,
        },
      }}
      extra={[
        <Space key="buttons">
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleOk} type="primary">
            Guardar
          </Button>
        </Space>
      ]}
    >
      {initialValues && (
        <Form
          layout="vertical"
          form={form}
          hideRequiredMark
          initialValues={initialValues}
          onFinish={handleOk}
        >
          <Row gutter={16}>
            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="banco_clave"
                label="Banco"
                rules={[
                  {
                    required: true,
                    message: 'Por favor selecciona un banco',
                  },
                ]}
              >
                <Select
                  placeholder="Selecciona un banco"
                  allowClear
                >
                  {bancos.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.text}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="formato"
                label="Formato"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingresa el formato',
                  },
                ]}
              >
                <Input placeholder="Ingresa el formato" />
              </Form.Item>
            </Col>

            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="activo"
                label="Activo"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                />
              </Form.Item>
            </Col>

            <Col md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item
                name="comentarios"
                label="Comentarios"
              >
                <TextArea
                  placeholder="Ingresa comentarios adicionales"
                  rows={4}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Drawer>
  );
};

export default App;